"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRuleTypeV2AsString = exports.RuleTypeV2 = void 0;
var RuleTypeV2;
(function (RuleTypeV2) {
    RuleTypeV2[RuleTypeV2["Uninitialized"] = 0] = "Uninitialized";
    RuleTypeV2[RuleTypeV2["AdditionalSigner"] = 1] = "AdditionalSigner";
    RuleTypeV2[RuleTypeV2["All"] = 2] = "All";
    RuleTypeV2[RuleTypeV2["Amount"] = 3] = "Amount";
    RuleTypeV2[RuleTypeV2["Any"] = 4] = "Any";
    RuleTypeV2[RuleTypeV2["Frequency"] = 5] = "Frequency";
    RuleTypeV2[RuleTypeV2["IsWallet"] = 6] = "IsWallet";
    RuleTypeV2[RuleTypeV2["Namespace"] = 7] = "Namespace";
    RuleTypeV2[RuleTypeV2["Not"] = 8] = "Not";
    RuleTypeV2[RuleTypeV2["Pass"] = 9] = "Pass";
    RuleTypeV2[RuleTypeV2["PdaMatch"] = 10] = "PdaMatch";
    RuleTypeV2[RuleTypeV2["ProgramOwned"] = 11] = "ProgramOwned";
    RuleTypeV2[RuleTypeV2["ProgramOwnedList"] = 12] = "ProgramOwnedList";
    RuleTypeV2[RuleTypeV2["ProgramOwnedTree"] = 13] = "ProgramOwnedTree";
    RuleTypeV2[RuleTypeV2["PubkeyListMatch"] = 14] = "PubkeyListMatch";
    RuleTypeV2[RuleTypeV2["PubkeyMatch"] = 15] = "PubkeyMatch";
    RuleTypeV2[RuleTypeV2["PubkeyTreeMatch"] = 16] = "PubkeyTreeMatch";
})(RuleTypeV2 = exports.RuleTypeV2 || (exports.RuleTypeV2 = {}));
const getRuleTypeV2AsString = (type) => {
    switch (type) {
        case RuleTypeV2.AdditionalSigner: // 1
            return 'AdditionalSigner';
        case RuleTypeV2.All: // 2
            return 'All';
        case RuleTypeV2.Amount: // 3
            return 'Amount';
        case RuleTypeV2.Any: // 4
            return 'Any';
        case RuleTypeV2.Frequency: // 5
            // return 'Frequency';
            throw new Error('Frequency Rule is not supported yet');
        case RuleTypeV2.IsWallet: // 6
            // return 'IsWallet';
            throw new Error('IsWallet Rule is not supported yet');
        case RuleTypeV2.Namespace: // 7
            return 'Namespace';
        case RuleTypeV2.Not: // 8
            return 'Not';
        case RuleTypeV2.Pass: // 9
            return 'Pass';
        case RuleTypeV2.PdaMatch: // 10
            return 'PdaMatch';
        case RuleTypeV2.ProgramOwned: // 11
            return 'ProgramOwned';
        case RuleTypeV2.ProgramOwnedList: // 12
            return 'ProgramOwnedList';
        case RuleTypeV2.ProgramOwnedTree: // 13
            return 'ProgramOwnedTree';
        case RuleTypeV2.PubkeyListMatch: // 14
            return 'PubkeyListMatch';
        case RuleTypeV2.PubkeyMatch: // 15
            return 'PubkeyMatch';
        case RuleTypeV2.PubkeyTreeMatch: // 16
            return 'PubkeyTreeMatch';
        case RuleTypeV2.Uninitialized: // 0
        default:
            throw new Error(`Unknown rule type: ${type}`);
    }
};
exports.getRuleTypeV2AsString = getRuleTypeV2AsString;
//# sourceMappingURL=ruleType.js.map